import { atom } from "recoil";

export type VisibilityTypes = {
  showMainHeader: boolean;
  showCategories: boolean;
  showBlog: boolean;
  showTitles: boolean;
};

export const visibilityAtom = atom<VisibilityTypes>({
  key: "visibilityAtom",
  default: {
    showBlog: false,
    showCategories: true,
    showMainHeader: true,
    showTitles: false,
  },
});
